<div class="futures-footer" *transloco="let t; read: 'app.futures.footer'">
  <div class="futures-footer__top">
    <div class="futures-footer__links-wrapper">
      <ul class="futures-footer__links">
        <li class="futures-footer__copyright">{{ t("copyright", { year: currentYear }) }}</li>
        <li class="futures-footer__dot coloured-dot futures-footer__dot--after-copyright"></li>
        <li class="futures-footer__link-item">
          <a
            href="https://brightfunded.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            class="futures-footer__link"
            >{{ t("link.privacyPolicy") }}</a
          >
        </li>
        <li class="futures-footer__dot coloured-dot"></li>
        <li class="futures-footer__link-item">
          <a
            href="https://brightfunded.com/futures/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
            class="futures-footer__link"
            >{{ t("link.termsAndConditions") }}</a
          >
        </li>
        <li class="futures-footer__dot coloured-dot"></li>
        <li class="futures-footer__link-item">
          <a
            href="https://brightfunded.com/futures/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
            class="futures-footer__link"
            >{{ t("link.riskDisclosure") }}</a
          >
        </li>
      </ul>
    </div>
  </div>

  <div class="futures-footer__separator"></div>

  <div class="futures-footer__description">
    <p class="futures-footer__desc-text">{{ t("shortDescription") }}</p>
    <button
      class="futures-footer__expand-btn"
      [class.futures-footer__expand-btn--open]="textVisible()"
      (click)="additionalText()"
    >
      <app-svg-icon icon="assets/images/icon-chevron.svg" [blank]="true" />
    </button>
  </div>
  <div
    class="futures-footer__long-desc"
    [class.futures-footer__long-desc--expanded]="textVisible()"
  >
    <p class="futures-footer__long-desc-text" [innerHTML]="t('longDescription') | lineBreaks"></p>
  </div>
  <div id="futuresFooterTarget"></div>
</div>
